import React from 'react'

const MainSection = ({ mainStyles, totalStake }) => {
    return (
        <section className={`${mainStyles.main}`} >
            <h2 className={`${mainStyles.tit}`} >
                MMT Staking<br />
                makes passive income<br />
                on your assets
            </h2>
            <div className={`${mainStyles.psr}`} >
                <img src={require(`../../assert/img/img_mainvisual.png`)} alt="메인 이미지" />
                <div className={`${mainStyles.overviewWrap}`} >
                    <div className={`${mainStyles.tit}`} >Overview</div>
                    <div className={`${mainStyles.totalWrap}`} >
                        <div className={`${mainStyles.tit}`} >Total Stake</div>
                        <div className={`${mainStyles.cont}`} >{totalStake} MMT</div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default MainSection